import React from 'react';

import { Button } from 'semantic-ui-react';
import { formatCentAmount } from '../../lib/formatters.js';

export class ProcessedSpendLine extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      totalSpendFulfilled: props.totalSpendFulfilled || 0,
    };
  }

  render() {
    return (
      <div className="processed-spend-line">
        {!this.state.show && (
          <Button
            className="insights-refresh-button brand-bg-color-override"
            onClick={() => {
              this.setState({ show: true });
            }}>
            View Fulfilled Spend
          </Button>
        )}
        {this.state.show && (
          <h5 className="total-spend-header total-office-spend">
            <span>Fulfilled Spend</span>
            <strong>{formatCentAmount(this.props.totalSpendFulfilled)}</strong>
          </h5>
        )}
      </div>
    );
  }
}

export default ProcessedSpendLine;
